import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PatientobstericsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PregancyLossOptions {
  value: string;
  text: string;
}


export interface PatientobstericsreasonForProcedure {
  id?: any;
  regId: any;
  reasonForProcedure: any;
  patientObstericsId: any;
  parameters?: PatientobstericsParameter[];
  links?: any;
}

export interface PatientobstericsMst {
    id?: any; 
    regId: any;
  pregnancyRecordNumber: string;
    firstConsultDate:Date;
    initialUltrasound:Date;
   prePregancyweight:any;
    lmP_date:Date;
    edd:Date;
    delivery_Date:Date;
    picme:string;

    tenantId: any;
    branchId: any;

  pregancyLoss: any;
  pregancyLossReason: any;
  pregancyLossWeek: any;
  pregancyLossDate: Date;
  pregancyLossNotes: any;
  deliveryType: any;
  fetusVital: any;
  deliveryNotes: any;
  uptPositiveDate: Date;
  g: number;
  p:number;
  l:number;
  a:number;
  correctedEdd:Date;
  gplaNotes?:any;
    parameters?: PatientobstericsParameter[];
    links?: any;
    //log
    createdDate?:Date;
    updatedDate?:Date;
    createdBy?:number;
    updatedBy?:number;
    createdIP?:string;
    updatedIP?:string;
}

export abstract class PatientobstericsData { 

  abstract list(url: string): Observable<PatientobstericsMst[]>;
  abstract listPatientobstericsreasonForProcedure(url: string): Observable<PatientobstericsreasonForProcedure[]>;

  abstract create(url: string, data: PatientobstericsMst): Observable<any>;
  abstract createPatientobstericsreasonForProcedure(url: string, data: PatientobstericsreasonForProcedure[]): Observable<any>;

    abstract update(url: string, data: PatientobstericsMst): Observable<any>;
    abstract delete(url: string): Observable<any>; 
  abstract deletePatientobstericsreasonForProcedure(url: string): Observable<any>; 

}
